/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import analytics from "analytics/analytics";
import globals from "modules/globals";
import baustein from "baustein";

const TAB_CLASS = "tabbed-bottom-navigation__tab";

export default baustein.register("tabbed-bottom-navigation", {

    setupEvents(add) {
        add("click", `.${TAB_CLASS}`, this.onClick);
    },

    onClick(event) {
        event.preventDefault();
        const label = event.target.closest(`.${TAB_CLASS}`).text;
        analytics.event("Bottom Tab Nav", "Clicked", label).then(() => {
            globals.window.location = event.target.closest("a").href;
        });
    }
});

